(function () {
    console.log('[H-TITLE] Script init');

    const isPDP = document.body.classList.contains('template-product');
    console.log('[H-TITLE] is PDP:', isPDP);

    if (!isPDP) return;

    function upgradeTitles(root = document) {
      const titles = root.querySelectorAll('.product-item__product-title');
      console.log('[H-TITLE] Titles found:', titles.length);

      titles.forEach((title, index) => {
        const tag = title.tagName.toLowerCase();

        if (tag === 'h3') return;

        console.log(`[H-TITLE] Upgrading title #${index + 1} from ${tag} to h3`);

        const h3 = document.createElement('h3');

        [...title.attributes].forEach(attr => {
          h3.setAttribute(attr.name, attr.value);
        });

        h3.innerHTML = title.innerHTML;
        title.replaceWith(h3);
      });
    }

    // Primer intento (por si ya existen)
    upgradeTitles();

    // Observer para contenido dinámico
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;

          if (
            node.matches?.('.product-item__product-title') ||
            node.querySelector?.('.product-item__product-title')
          ) {
            console.log('[H-TITLE] Detected dynamic content');
            upgradeTitles(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    console.log('[H-TITLE] MutationObserver active');
  })();

  // ADU / Tabarnapp: redondear % del badge (ej. -33.33333333% → -33%)
  (function () {
    const SELECTOR = '.ProductVariant--DiscountValue';

    function formatDiscountText(text) {
      const match = String(text).trim().match(/^(-?\d+(?:\.\d+)?)\s*%$/);
      if (!match) return null;

      const raw = match[1];
      if (!raw.includes('.')) return null;

      const rounded = Math.round(Number(raw));
      if (!Number.isFinite(rounded)) return null;

      return `${rounded}%`;
    }

    function fixDiscountBadges(root = document) {
      const candidates = [];

      if (root instanceof HTMLElement && root.matches?.(SELECTOR)) {
        candidates.push(root);
      }

      if (root.querySelectorAll) {
        root.querySelectorAll(SELECTOR).forEach((el) => candidates.push(el));
      }

      candidates.forEach((el) => {
        const next = formatDiscountText(el.textContent);
        if (next && el.textContent.trim() !== next) {
          el.textContent = next;
        }
      });
    }

    function init() {
      fixDiscountBadges();

      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (!(node instanceof HTMLElement)) return;
              if (
                node.matches?.(SELECTOR) ||
                node.querySelector?.(SELECTOR) ||
                node.matches?.('.MainTabarnappUIContainer') ||
                node.querySelector?.('.MainTabarnappUIContainer')
              ) {
                fixDiscountBadges(node);
              }
            });
          }

          if (mutation.type === 'characterData') {
            const parent = mutation.target.parentElement;
            if (parent?.matches?.(SELECTOR)) {
              fixDiscountBadges(parent);
            }
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // ADU / Tabarnapp: cerrar una sola vez al cargar; luego no intervenir
  (function () {
    const ROOT_SELECTOR = '.MainTabarnappUIContainer';
    const CHEVRON_SELECTOR = '.chevron-minimize';

    let done = false;
    let observer = null;

    function tryCollapse() {
      if (done) return;

      const root = document.querySelector(ROOT_SELECTOR);
      if (!root) return;

      const expanded = root.querySelector(
        '.BottomBar-quest-container-expanded-completedQuests, [class*="BottomBar-quest-container-expanded"], .BottomBarExpandedTabs'
      );
      const chevron = root.querySelector(CHEVRON_SELECTOR);

      if (!expanded || !chevron) return;

      done = true;
      if (observer) observer.disconnect();

      // Cierre nativo de la app (una sola vez)
      chevron.click();
    }

    function init() {
      tryCollapse();

      observer = new MutationObserver(() => {
        tryCollapse();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      // Seguridad: dejar de observar aunque no encuentre chevron
      window.setTimeout(() => {
        done = true;
        if (observer) observer.disconnect();
      }, 2500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
